import { makeStyles } from '@mui/styles';

const useWidgetStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  w100: {
    width: '100%',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'between',
    alignItem: 'center',
  },
  title: {
    fontSize: '16px',
    margin: '20px 0',
  },
  widgetOption: {
    borderRadius: '4px',
    border: 'solid 1px #757575',
    padding: '8px 8px 8px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btn: {
    width: 96,
  },
  firstBtn: {
    width: 96,
    marginRight: 10,
  },
  mb10: {
    marginBottom: 10,
  },
  archivedText: {
    color: '#f50057',
  },
  text: {
    display: 'flex',
    alignItems: 'center',
  },
  addBtn: {
    color: 'blue',
    width: 36,
    marginRight: 10,
    cursor: 'pointer',
  },
  removeBtn: {
    color: 'red',
    width: 36,
    marginRight: 10,
    cursor: 'pointer',
  },
  configBtn: {
    width: 96,
    marginRight: '10px !important',
  },
  viewBtn: {
    width: 96,
  },
}));

export default useWidgetStyles;
